import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Typography,
  Paper,
  TextField,
  Alert,
  AlertTitle,
  Stack,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/system";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import DatePickers from "../../pickers/DatePicker";
import { Field, Form } from "react-final-form";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { useLocation } from "react-router-dom";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { fetchPaymentById, updatePayment } from "../../action";
import CalenderPicker from "../../pickers/CalenderPicker";
import PaymentDocuments from "./PaymentDocuments";
import { GedToken } from "../../utils/constant";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import CalendarPicker from "../../pickers/CalenderPicker";
import { formatDateFromISO } from "../../utils/helper";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { OnChange } from "react-final-form-listeners";
import moment from "moment";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
const StyledAlert = styled(Stack)(({ }) => ({
  marginLeft: "1.2rem",
}));

const StyledAlertTitle = styled(AlertTitle)(({ }) => ({
  fontWeight: "bold",
  color: "red",
}));

const StyledPaymentGrid = styled(Grid)(({ }) => ({
  //  overflowX: "auto",
  paddingBottom: "1.2rem",
  //  height: "20rem",
}));
const PayementForm = () => {
  const SignInSuccess = useSelector((state) => state);
  const FileSearch = useSelector((state) => state.profileReducer?.fileData);
  const documentData = useSelector(
    (state) => state.profileReducer?.documentData
  );

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const idWithPrefix = pathname.split("/").pop();
  const url = idWithPrefix.split("=")[1];
  const [paymentDetail, setPaymentDetail] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [receivedAmounts, setReceivedAmounts] = useState([
    { amount: "", receiptNo: "" },
  ]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [docsCheck, setDocsCheck] = useState(false);

  useEffect(() => {
    if (!!paymentDetail && !!paymentDetail.receivedAmountTransaction) {
      setReceivedAmounts(JSON.parse(paymentDetail.receivedAmountTransaction));
    }
  }, [paymentDetail]);

  const handleAddAmount = () => {
    setReceivedAmounts((prevAmounts) => [
      ...prevAmounts,
      { amount: "", receiptNo: "" },
    ]);
  };

  const handleRemoveAmount = (index, form) => {
    setReceivedAmounts((prevAmounts) =>
      prevAmounts.filter((_, i) => i !== index)
    );
    form.change(`receivedAmount${index + 1}`, "");
    form.change(`receiptNo${index + 1}`, "");
  };

  const handleAmountChange = (index, field, value) => {
    const updatedAmounts = [...receivedAmounts];
    updatedAmounts[index][field] = value;
    setReceivedAmounts(updatedAmounts);
    // updateAttribute(`receivedAmounts`, updatedAmounts);
  };

  const totalReceived = receivedAmounts
    ? receivedAmounts.reduce(
      (sum, item) => Number(sum) + Number(item.amount),
      0
    )
    : 0;

  const onSubmit = async (values) => {
    const payload = {
      values,
      ...paymentDetail,
      receivedAmounts: receivedAmounts,
      receivedDate: values.receivedDate
        ? values.receivedDate
        : moment().format("YYYY-MM-DD"),
    };
    dispatch(updatePayment(payload));
    setSnackbarMessage(t("Payment Submit Sucessfully"));
  };
  let mutation = SignInSuccess?.profileReducer?.mutations;
  useEffect(() => {
    if (snackbarMessage) {
      if (mutation && mutation.length > 0 && mutation[0]?.status === 2) {
        setSnackbarSeverity("success");
        // setSnackbarMessage('Isuree Successfully add in to policyholder.');
        setSnackbarOpen(true);
        handleFileCreate();
      } else if (mutation && mutation.length > 0 && mutation[0]?.status === 1) {
        setSnackbarSeverity("error");
        setSnackbarMessage(t("Failed to done any action in Payments."));
        setSnackbarOpen(true);
      } else if (!mutation) {
        setSnackbarOpen(false);
      }
    }
  }, [mutation]);

  const handleSnackbarClose = async (event, reason) => {
    // window.location.reload();
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (url) {
      dispatch(fetchPaymentById(url));
    }
  }, [mutation, docsCheck]);

  useEffect(() => {
    if (SignInSuccess?.profileReducer?.paymentDataById?.[0]) {
      setPaymentDetail(SignInSuccess?.profileReducer?.paymentDataById?.[0]);
    }
  }, [SignInSuccess?.profileReducer?.paymentDataById?.[0]]);

  const handleFileCreate = () => {
    const apiUrl = `${process.env.REACT_APP_GED_URL}/file/create?isUpdate=false&isDocVerified=true`;
    const headers = {
      Authorization: `Bearer ${GedToken}`,
      "Content-Type": "application/json",
    };
    const fileReq = { action: `SUBMIT`, fileId: FileSearch?.[0]?.id };
    fetch(`${apiUrl}`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(fileReq),
    })
      .then((response) => {
        if (!response.ok) {
          setSnackbarSeverity("error");
          setSnackbarMessage(t("There is no document inside the file"));
          setSnackbarOpen(true);
          setDocsCheck(true);
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        const fileRequestData = res;
        setSnackbarSeverity("success");
        // setSnackbarMessage(t("Document Submitted Sucessfully"));
        setSnackbarOpen(false);
        dispatch(fetchPaymentById(url));
        // dispatch(fetchFileRequest(fileRequestData));
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };

  const payemntType = [
    {
      value: "B",
      label: t("Bank Transfer"),
    },
    {
      value: "C",
      label: t("Cash"),
    },
    {
      value: "M",
      label: t("Mobile Phone"),
    },
    {
      value: "BC",
      label: t("Bank Cheque"),
    },
  ];
  const validate = (values) => {
    const errors = {};
    if (!values.typeOfPayment) {
      errors.typeOfPayment = t("Field is required");
    }
    // if (
    //   !!values.receivedAmount1 &&
    //   totalReceived !== Number(values?.expectedAmount)
    // ) {
    //   errors.receivedAmount1 = t("Recievedamountismorethantotaldue");
    // }
    receivedAmounts.forEach((item, index) => {
      if (!values[`receivedAmount${index + 1}`]) {
        errors[`receivedAmount${index + 1}`] = t("Field is required");
      }
    });
    receivedAmounts.forEach((item, index) => {
      if (!values[`receiptNo${index + 1}`]) {
        errors[`receiptNo${index + 1}`] = t("Field is required");
      }
    });
    return errors;
  };
  const goBack = () => {
    navigate(-1); // Navigate back one step in history
  };

  const receivedAmountTransactions = paymentDetail?.receivedAmountTransaction
    ? JSON.parse(paymentDetail.receivedAmountTransaction)
    : [];

  const initialValues = {
    requestDate: paymentDetail?.requestDate ? paymentDetail?.requestDate : "",
    declarationValidFrom: paymentDetail?.contract?.dateValidFrom
      ? paymentDetail?.contract?.dateValidFrom
      : "",
    declarationValidTo: paymentDetail?.contract?.dateValidTo
      ? paymentDetail?.contract?.dateValidTo
      : "",
    expectedAmount: paymentDetail?.expectedAmount
      ? paymentDetail?.expectedAmount
      : "",
    parentPendingPayment: paymentDetail?.parentPendingPayment
      ? paymentDetail?.parentPendingPayment
      : "",
    contractPenaltyAmount: paymentDetail?.contractPenaltyAmount
      ? paymentDetail?.contractPenaltyAmount
      : "",
    parentPaymentPenalty: paymentDetail?.parentPaymentPenalty
      ? paymentDetail?.parentPaymentPenalty
      : "",
    typeOfPayment: paymentDetail?.typeOfPayment
      ? paymentDetail?.typeOfPayment
      : "",
    paymentId: paymentDetail?.paymentCode ? paymentDetail?.paymentCode : "",
    declarationId: paymentDetail?.contract?.code
      ? paymentDetail?.contract?.code
      : "",

    // receivedAmountOne: paymentDetail?.receivedAmountOne
    //   ? paymentDetail?.receivedAmountOne
    //   : "",
    // receiptNo: paymentDetail?.receiptNo ? paymentDetail?.receiptNo : "",
    // receivedAmountTwo: paymentDetail?.receivedAmountTwo
    //   ? paymentDetail?.receivedAmountTwo
    //   : "",
    // receiptNoTwo: paymentDetail?.receiptNoTwo
    //   ? paymentDetail?.receiptNoTwo
    //   : "",
    // receivedAmountThree: paymentDetail?.receivedAmountThree
    //   ? paymentDetail?.receivedAmountThree
    //   : "",
    // receiptNoThree: paymentDetail?.receiptNoThree
    //   ? paymentDetail?.receiptNoThree
    //   : "",
    ...receivedAmountTransactions.reduce((acc, transaction, index) => {
      const amountKey = `receivedAmount${index + 1}`;
      const receiptKey = `receiptNo${index + 1}`;
      acc[amountKey] = transaction.amount || "";
      acc[receiptKey] = transaction.receiptNo || "";
      return acc;
    }, {}),
  };
  return (
    <Grid>
      <Grid>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={goBack}
          style={{ marginLeft: ".5rem", color: "black" }}
        >
          {t("Back to Payment")}
        </Button>
      </Grid>
      <Grid style={{ display: "flex", width: "100%" }}>
        <Typography style={{ marginLeft: "1.2rem" }} variant="h6">
          {t("Payments")}
        </Typography>
        <Grid style={{ marginLeft: "auto", marginRight: "1.2rem" }}>
          <Typography variant="h6">
            {t("Payment Status")}
            <span
              style={{
                color:
                  paymentDetail?.status === -1 ||
                    paymentDetail?.status === -2 ||
                    paymentDetail?.status === -3
                    ? "red"
                    : "green",
                fontWeight: "bold",
              }}
            >{`${t(paymentDetail?.status)}`}</span>
          </Typography>
        </Grid>
      </Grid>
      {paymentDetail?.rejectedReason && paymentDetail?.status == -1 && (
        <Grid container style={{ maxWidth: "fit-content" }}>
          <StyledAlert>
            <Alert
              severity="error"
              sx={{
                border: "1px solid red",
                backgroundColor: "#ffe6e6", // light red background
                color: "red",
              }}
            >
              <StyledAlertTitle>
                {paymentDetail?.rejectedReason &&
                  t("Payment is rejected with the following reason")}
              </StyledAlertTitle>
              {paymentDetail?.rejectedReason && (
                <Typography>
                  {t("Comment")}: {t(paymentDetail?.rejectedReason)}
                </Typography>
              )}
            </Alert>
          </StyledAlert>
        </Grid>
      )}
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
        render={({
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
          errors,
        }) => (
          // setFormValues(values),
          <form onSubmit={handleSubmit}>
            <Grid container>
              <Grid item xs={6}>
                <StyledPaper>
                  <Grid>
                    <StyledPaperHeader>
                      {/* <Grid></Grid> */}
                      <Grid alignItems="center">
                        <Typography variant="h6">
                          {t("Payment Details")}
                        </Typography>
                      </Grid>
                    </StyledPaperHeader>

                    <Grid
                      container
                      style={{ margin: ".5rem .5rem .5rem .5rem" }}
                    >
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="paymentId"
                          component={TextInput}
                          label={t("paymentId")}
                          value={paymentDetail?.paymentCode}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="declarationId"
                          component={TextInput}
                          label={t("declarationId")}
                          value={paymentDetail?.contract?.code}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="requestDate"
                          component={CalendarPicker}
                          label={t("Request Date")}
                          value={values.requestDate}
                          disabled={true}
                          inputVal={formatDateFromISO(
                            paymentDetail?.requestDate
                          )}
                          formatDate="DD-MM-YYYY"
                        />
                      </Grid>
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="declarationValidFrom"
                          component={CalendarPicker}
                          label={t("Declaration Valid From")}
                          onChange={(value) =>
                            form.change("declarationValidFrom", value)
                          }
                          inputVal={formatDateFromISO(
                            paymentDetail?.contract?.dateValidFrom
                          )}
                          disabled={true}
                          formatDate="DD-MM-YYYY"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className="common-input"
                        style={{ marginTop: "2px" }}
                      >
                        <Field
                          name="declarationValidTo"
                          component={CalenderPicker}
                          label={t("Declaration Valid To")}
                          disabled={true}
                          inputVal={formatDateFromISO(
                            paymentDetail?.contract?.dateValidTo
                          )}
                          formatDate="DD-MM-YYYY"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className="common-input"
                        style={{ marginTop: "2px" }}
                      >
                        <Field
                          name="receivedDate"
                          component={CalenderPicker}
                          label={t("receivedDate")}
                          disabled={true}
                          inputVal={
                            paymentDetail?.receivedDate
                              ? formatDateFromISO(paymentDetail?.receivedDate)
                              : moment().format("DD-MM-YYYY")
                          }
                          formatDate="DD-MM-YYYY"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className="common-input"
                        style={{ marginTop: "2px" }}
                      >
                        <Field
                          name="approvedDate"
                          component={CalenderPicker}
                          label={t("approvedDate")}
                          disabled={true}
                          inputVal={formatDateFromISO(
                            paymentDetail?.matchedDate
                          )}
                          formatDate="DD-MM-YYYY"
                        />
                      </Grid>
                      {/* <Grid item xs={6} className="common-input">
                        <Field
                          name="expectedAmount"
                          component={TextInput}
                          label={t("Current Due")}
                          type="text"
                          disabled={true}
                        />
                      </Grid> */}
                      {/* <Grid item xs={6} className="common-input">
                        <Field
                          name="parentPendingPayment"
                          component={TextInput}
                          label={t("Previous Due")}
                          type="text"
                          disabled={true}
                        />
                      </Grid> */}
                      {/* <Grid item xs={6} className="common-input">
                        <Field
                          name="contractPenaltyAmount"
                          component={TextInput}
                          label={t("Declaration Penalty Amount")}
                          type="text"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} className="common-input">
                        <Field
                          name="parentPaymentPenalty"
                          component={TextInput}
                          label={t("Payment Penalty Amount")}
                          type="text"
                          disabled={true}
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                </StyledPaper>
              </Grid>
              <Grid item xs={6}>
                <StyledPaper>
                  <StyledPaymentGrid>
                    <StyledPaperHeader>
                      {/* <Grid></Grid> */}
                      <Grid
                        display={"flex"}
                        justifyContent={"space-between"}
                        item
                        alignItems="center"
                      >
                        {/* <Typography variant="h6">
                        {t("Payment Proofs")}
                      </Typography> */}
                        <Typography variant="h6">
                          {t("Total Due with Penalty")}:
                          <span style={{ color: "#FF0000" }}>{`${paymentDetail?.expectedAmount
                              ? paymentDetail?.expectedAmount
                              : ""
                            }`}</span>
                        </Typography>
                        <Typography variant="h6">
                          {t("receivedAmount")}:
                          <span style={{ color: "#00913E" }}>{`${paymentDetail?.receivedAmount
                              ? paymentDetail?.receivedAmount
                              : totalReceived
                            }`}</span>
                        </Typography>
                      </Grid>
                    </StyledPaperHeader>
                    <Grid
                      container
                      style={{ margin: ".5rem .5rem .5rem .5rem" }}
                    >
                      <Grid item xs={8} className="common-input">
                        <Field
                          name="typeOfPayment"
                          component={Dropdown}
                          label={t("Payment Type")}
                          required={true}
                          options={payemntType}
                          error={errors.typeOfPayment}
                        />
                      </Grid>

                      {receivedAmounts.map((receivedAmount, index) => {
                        return (
                          <Grid container key={index} alignItems="center">
                            <Grid item xs={6} className="common-input no-arrow">
                              <Field
                                name={`receivedAmount${index + 1}`}
                                component={TextInput}
                                isAmount
                                label={t(`Payment Amount ${index + 1}`)}
                                // required={receivedAmount.amount ? true : false}
                                required={true}
                                disabled={
                                  receivedAmountTransactions.length > 0 &&
                                    paymentDetail?.status !== -1
                                    ? true
                                    : false
                                }
                                error={errors[`receivedAmount${index + 1}`]}
                              />
                              <OnChange name={`receivedAmount${index + 1}`}>
                                {(value, previous) => {
                                  handleAmountChange(index, "amount", value);
                                }}
                              </OnChange>
                            </Grid>
                            <Grid item xs={6} className="common-input">
                              {/* <AmountInput */}
                              <Field
                                name={`receiptNo${index + 1}`}
                                component={TextInput}
                                required={true}
                                label={t(
                                  `Payment Proof Reference ${index + 1}`
                                )}
                                onChange={(p) =>
                                  handleAmountChange(index, "amount", p)
                                }
                                prefillValue={receivedAmount.receiptNo}
                                disabled={
                                  receivedAmountTransactions.length > 0 &&
                                    paymentDetail?.status !== -1
                                    ? true
                                    : false
                                }
                                error={errors[`receiptNo${index + 1}`]}
                              />
                              <OnChange name={`receiptNo${index + 1}`}>
                                {(value, previous) => {
                                  handleAmountChange(index, "receiptNo", value);
                                }}
                              </OnChange>
                            </Grid>

                            <Grid item xs={2} className="common-input">
                              {index > 0 &&
                                receivedAmountTransactions.length == 0 && (
                                  <IconButton
                                    onClick={() =>
                                      handleRemoveAmount(index, form)
                                    }
                                    color="error"
                                  >
                                    <DeleteOutlineOutlinedIcon />
                                  </IconButton>
                                )}
                            </Grid>
                          </Grid>
                        );
                      })}
                      <Grid item xs={12}>
                        <Button
                          onClick={handleAddAmount}
                          color="primary"
                          variant="outlined"
                          startIcon={<AddIcon />}
                          disabled={
                            (receivedAmountTransactions.length > 0 &&
                              paymentDetail?.status !== -1) ||
                              (!receivedAmounts[0].amount &&
                                !receivedAmounts[0].receiptNo &&
                                paymentDetail?.status !== -1)
                              ? true
                              : false
                          }
                        >
                          {t("newTransaction")}
                        </Button>
                        {!!values.receivedAmount1 &&
                          totalReceived !== Number(values?.expectedAmount) && (
                            <Typography
                              color="red"
                              fontSize={".8rem"}
                              align={"center"}
                              sx={{ marginTop: ".4rem" }}
                            >
                              {" "}
                              {t("Recievedamountismorethantotaldue")}
                            </Typography>
                          )}
                      </Grid>
                      {/* <Grid item xs={6} className="common-input no-arrow">
                                            <Field
                                                name="receivedAmountOne"
                                                component={TextInput}
                                                label={t("Payment Amount 1")}
                                                type="number"
                                                isAmount
                                                required
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                                error={errors.receivedAmountOne}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            className="common-input"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <Field
                                                name="receiptNo"
                                                component={TextInput}
                                                label={t("Payment Proof Reference 1")}
                                                required
                                                type="text"
                                                // disabled={
                                                //     !!paymentDetail?.receivedAmountOne ? true : false
                                                // }
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} className="common-input no-arrow">
                                            <Field
                                                name="receivedAmountTwo"
                                                component={TextInput}
                                                label={t("Payment Amount 2")}
                                                type="number"
                                                isAmount
                                                // disabled={
                                                //     !!paymentDetail?.receivedAmountTwo ? true : false
                                                // }
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                                error={errors.receivedAmountTwo}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className="common-input">
                                            <Field
                                                name="receiptNoTwo"
                                                component={TextInput}
                                                label={t("Payment Proof Reference 2")}
                                                type="text"
                                                // disabled={
                                                //     !!paymentDetail?.receivedAmountTwo ? true : false
                                                // }
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} className="common-input no-arrow">
                                            <Field
                                                name="receivedAmountThree"
                                                component={TextInput}
                                                label={t("Payment Amount 3")}
                                                type="number"
                                                isAmount
                                                // disabled={
                                                //     !!paymentDetail?.receivedAmountThree ? true : false
                                                // }
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                                error={errors.receivedAmountThree}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className="common-input">
                                            <Field
                                                name="receiptNoThree"
                                                component={TextInput}
                                                label={t("Payment Proof Reference 3")}
                                                type="text"
                                                
                                                // disabled={
                                                //     !!paymentDetail?.receivedAmountThree ? true : false
                                                // }
                                                disabled={
                                                    paymentDetail?.status == -1 || paymentDetail?.status == 1
                                                        ? false
                                                        : true
                                                }
                                            />
                                        </Grid> */}
                    </Grid>
                  </StyledPaymentGrid>
                </StyledPaper>
              </Grid>
            </Grid>
            {documentData?.length > 0 &&
              FileSearch?.[0].status === "Pending_Scan" ? (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                // size="small"
                disabled={
                  submitting ||
                  pristine ||
                  [5, 3, 2].includes(paymentDetail?.status) ||
                  Object.keys(errors).length > 0
                  ||
                  (receivedAmounts &&
                    receivedAmounts.some((item) => !item.receiptNo) &&
                    Number(totalReceived) !==
                    Number(paymentDetail?.expectedAmount)) || !!values.receivedAmount1 &&
                  totalReceived !== Number(values?.expectedAmount)
                }
                style={{ float: "right" }}
              >
                {t("Submit Payment")}
              </Button>
            ) : (
              ""
            )}
          </form>
        )}
      />
      <Grid style={{ width: "51%" }}>
        <StyledPaper>
          <StyledPaperHeader>
            {/* <Grid></Grid> */}
            <Grid style={{ display: "flex" }} item alignItems="center">
              <Typography variant="h6">{t("Documets Upload")}</Typography>
              {/* {FileSearch?.[0].status === "Pending_Scan" && !!documentData && (
                                <Button
                                    onClick={handleFileCreate}
                                    variant="outlined"
                                    color="primary"
                                    style={{ marginLeft: "auto" }}
                                >
                                    {t("Submit Document")}
                                </Button>
                            )} */}
            </Grid>
          </StyledPaperHeader>
        </StyledPaper>
        <Grid container>
          <PaymentDocuments
            paymentDetail={paymentDetail}
            snackbarOpen={snackbarOpen}
          />
        </Grid>
      </Grid>
      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Grid>
  );
};

export default PayementForm;
